import React from 'react';
import FrameworksTab from '../components/frameworks/FrameworksTab';

interface FrameworksProps {
    dashboard?: boolean;
}

const Frameworks: React.FC<FrameworksProps> = ({ dashboard }) => {
    return (
        <div className='px-4'>
            <div className="flex items-center justify-between mb-6">
                <div className="mb-4">
                    <h1 className="text-2xl font-bold italic text-[#0F2A4F]">Frameworks</h1>
                </div>
            </div>
            <FrameworksTab dashboard={dashboard} />
        </div>
    );
};

export default Frameworks;
